module.exports = __webpack_public_path__ + "media/shape_of_you.864d8ed8.mp3";